





































































































































import { ref, computed, defineComponent, watch } from '@vue/composition-api';
import ChartsCard from '../charts-card.vue';
import ChartsLine from '../charts-line.vue';
import SelectNav from '../select-nav.vue';
import MapTable from '../map-table.vue';
import ModuleTitle from '../module-title.vue';
import { useRetentionData } from '../../hooks/retention-data';
import { createFilterForm, filterSetting, defaultRetentionCardTime, pickerOptions } from '../../filter';
import { handleErrorMessageToast, handleWarningMessageToast } from '@/common/util';
import { FilterFormItemType, ChartsType, ChartType } from '../../types';
import throttle from 'lodash/throttle';
import IconText from '../iconText.vue';

export default defineComponent({
    name: "retention-data", // 留存分析
    components: {
        ModuleTitle,
        ChartsCard,
        ChartsLine,
        SelectNav,
        MapTable,
        IconText
    },
    props: {
        tabActive: {
            type: String,
            default: ''
        },
        appId: {
            type: String,
            required: true
        },
        gameType: {
            type: String,
            required: true,
            // default: 'iaa'
        }
    },
    setup(props, context) {
        const cardDateTime = ref(defaultRetentionCardTime);
        const {
            newTrendChartsConfig,
            newCompareChartsConfig,
            selectList,
            fillterCardForm,
            fillterForm,
            dashboardData,
            newCardConfig,
            cardData,
            trendChartsData,
            compareChartsData,
            downLoading,
            tableData,
            cardLoading,
            tableDownload,
            getDashboard,
            getCardChart,
            getBatchChart,
            getTableChart
        } = useRetentionData(props, context)
        // const activeArray = ref<string[]>([]); // card 的选中指标list
        const allLoading = ref(false);
        // const chartsComponents = ref(null) as any;

        // 切换card部分 筛选日期
        function pickCardDateChange() {
            const startTimeIndex =  fillterCardForm.value.findIndex((item: FilterFormItemType) => item.fieldName === 'start_time');
            const endTimeIndex =  fillterCardForm.value.findIndex((item: FilterFormItemType) => item.fieldName === 'end_time');
            fillterCardForm.value[startTimeIndex].fieldValue = cardDateTime.value;
            fillterCardForm.value[endTimeIndex].fieldValue = cardDateTime.value;
            // 获取单日留存数据概览——card
            getCardChart()
        }

        // 点击重置
        function clicRest() {
            const conditions = dashboardData.value.conditions
            fillterForm.value = createFilterForm(conditions, props.appId);
        }

        // 筛选条件变化时清空当前页面所有数据
        function clearAllChartData() {
            trendChartsData.value = [];
            compareChartsData.value = [];
        }

        // 根据当前config 找到configItem对应的data
        function findTrendChartItemData(configItem: ChartsType) {
            return trendChartsData.value.find((val: ChartType) => val && val.chartId === configItem.chartId);
        }

        // 根据当前config 找到configItem对应的data
        function findCompareChartItemData(configItem: ChartsType) {
            return compareChartsData.value.find((val: ChartType) => val && val.chartId === configItem.chartId);
        }


        // 获取指标详情-chart的补充文案
        function subText(configItem: ChartsType) {
            return filterSetting(configItem.chartSetting).subText || '';
        }

        // 获取chartSetting里 获取是否展示为整数的配置
        function showInteger(configItem: ChartsType) {
            return filterSetting(configItem.chartSetting).showInteger || false;
        }

        // 当前展示的table 数据是否已经准备好，没有不展示下载按钮
        const tableDataOK = computed(() => {
            return !!tableData.value;
        })

        // 下载表格
        function clickTableDown() {
            if(downLoading.value) {
                handleWarningMessageToast('正在下载表格中...');
                return;
            }
            tableDownload();
        }

        // 防止连续点击
        const clickTableDownThrottle = throttle(clickTableDown, 1000, { 'trailing': false })

        // 滚动到指定位置
        function scrollPos(id: string) {
            const ele = document.getElementById(id);
            if (!ele) return;
            window.scrollTo({ top: ele.offsetTop - 20, behavior: 'smooth' });
        }

        // 页面初始化
        async function init() {
            // 接口请求顺序 1、getDashboard 2、触发filterForm查询条件，请求详情和对比（批量接口）
            allLoading.value = true;
            Promise.all([
                // 清空当前页面所有数据
                clearAllChartData(),
                getBatchChart(),
                getBatchChart('compare'),
                // 获取初始表格chart
                getTableChart()
            ]).finally(() => {
                allLoading.value = false;
                context.emit('loadOver', allLoading.value);
                console.log('所有接口请求完毕')
            })
        }

        watch(
            () => fillterForm.value,
            (val) => {
                if(allLoading.value) {
                    handleWarningMessageToast('操作太频繁了，请等一等数据~')
                    return;
                }
                // 页面初始化 之前还会请求 getDashboard，getDashboard返回筛选条件后才会触发watch
                init();
            },
            {
                deep: true
            }
        );
        watch(
            () => props.appId,
            async (val) => {
                if(allLoading.value) {
                    handleWarningMessageToast('操作太频繁了，请等一等数据~')
                    return;
                }
                // 重新请求dashbord，会重置所有筛选条件，触发上方的watch
                await getDashboard()
                // 获取单日留存数据概览——card，因为查询条件和其他部分不一样，不通过fillterForm触发，需要进入页面单独请求
                getCardChart()
            }
        );


        return {
            scrollPos,
            pickerOptions,
            cardLoading,
            filterSetting,
            tableData,
            clickTableDownThrottle,
            tableDataOK,
            downLoading,
            newCompareChartsConfig,
            findCompareChartItemData,
            showInteger,
            subText,
            findTrendChartItemData,
            newTrendChartsConfig,
            selectList,
            cardDateTime,
            fillterCardForm,
            // chartsComponents,
            clicRest,
            pickCardDateChange,
            // clickCard,
            fillterForm,
            newCardConfig,
            cardData,
            allLoading
        }
    }
})
